export default __webpack_public_path__ + "static/media/es.c83946d1.jpg";